import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

const useStyles = makeStyles()((theme) => ({
  container: {
    ...dFlex('unset', 'unset'),
    flexDirection: 'column',
    gap: '16px',
    textAlign: 'center',
  },
  inputContainer: {
    ...dFlex('unset', 'flex-end'),
    flexDirection: 'column',
    gap: 4,
    width: '100%',
  },
  skeleton: {
    width: '60px !important',
  },
  totalBlock: {
    background: theme.palette.custom.background.accent,
    padding: '8px',
    borderRadius: theme.borderRadius.md,
    ...dFlex('unset', 'unset'),
    gap: '8px',
    flexDirection: 'column',
  },
  row: {
    ...dFlex('space-between', 'center'),
  },
}));

export default useStyles;
